<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import Aws from "@/services/Aws";
import Swal from "sweetalert2";
import ModalAddParameterStoreData from "@/components/modals/monitor/aws/modalAddParameterStoreData";

export default {
    components: { Layout, PageHeader, ModalAddParameterStoreData },
    data() {
        return {
            title: "Parameter Store",
            error: null,
            tableData: [],
            currentPage: 1,
            perPage: 25,
            items: [
                {
                    text: "AWS",
                },
                {
                    text: "AWS Parameter Store",
                    active: true,
                },
            ] ,
            pageOptions: [25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "LastModifiedDate",
            sortDesc: true,
            isBusy: false,
            fields: [
                {
                    key: "Name",
                    label: "Name",
                    sortable: true,
                },
                {
                    key: "Type",
                    label: "Type",
                    sortable: false,
                },
                {
                    key: "DataType",
                    label: "Data Type",
                    sortable: false,
                },
                {
                    key: "Value",
                    label: "Value",
                    sortable: false,
                },
                {
                    key: "LastModifiedDate",
                    label: "Last Modified Date",
                    sortable: true,
                },
                "action",
            ],
            totalRows: 0,
            showModal: false
        };
    },
    async mounted() {
        await this.getParameterStore()
    },
    methods: {
        async getParameterStore() {
            try {
                this.isBusy = true;
                const response = await Aws.getParameterStore();
                this.originalTableData = response.data.data;
                this.tableData = [...this.originalTableData];
                this.totalRows = this.tableData.length;
            } catch (error) {
                this.error = error.response.data.error ? error.response.data.error : "";
                this.tableData = [];
                this.totalRows = 0;
            } finally {
                this.showLoader = false;
                this.isBusy = false;
            }
        },

        async callmodaleditParameterStore(parameterData){

            Swal.fire({
                title: "Edit Parameter <br/>"+parameterData.Name+"?",
                html: `
                        <p>New Value:</p>
                        <input type="text" id="new_value" class="swal2-input" autocomplete="off" value="${parameterData.Value}">
                    `,
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Submit",
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    const newValueText = Swal.getPopup().querySelector("#new_value").value;

                    return Aws.editParameterStoreValue({
                        Name: parameterData.Name,
                        Value: newValueText,
                        Type: parameterData.Type,
                    })
                        .then((response) => {
                            return response;
                        })
                        .catch((error) => {
                            let errorMsg = error.response.data.error
                                ? error.response.data.error
                                : "";
                            this.failedmsg("Fail!", errorMsg);
                        });
                },
            }).then((result) => {
                if (result) {
                    const res = result.value.data.data ? result.value.data.data.success : false;
                    const error = result.value.data.error
                        ? result.value.data.error
                        : "Failed";

                    if (res) {
                        this.successmsg('Parameter Modified', 'Parameter Store Value successfuly modified')
                        this.getParameterStore()
                    } else {
                        this.warningmsg("Fail!", error);
                    }
                }
            });
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        addNewParameter(){
          this.$bvModal.show("addNewParameter");
        },

      removeParameterValue(parameterName){
        Swal.fire({
          title: "Remove Parameter <br/>"+parameterName+"?",
          icon: "warning",
          html: `
                        <p>Type "Delete" to confirm:</p>
                        <input type="text" id="deleteConfirmation" class="swal2-input" autocomplete="off">
                    `,
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: "Delete",
          showLoaderOnConfirm: true,
          preConfirm: () => {
            const confirmationText = Swal.getPopup().querySelector(
                "#deleteConfirmation"
            ).value;
            if (confirmationText.toLowerCase() !== "delete") {
              Swal.showValidationMessage('You must type "Delete" to confirm');
              return false;
            }

            return Aws.removeParameterValue("Name="+parameterName)
                .then((response) => {
                  return response;
                })
                .catch((error) => {
                  let errorMsg = error.response.data.error
                      ? error.response.data.error
                      : "";
                  this.failedmsg("Fail!", errorMsg);
                });
          },
        }).then((result) => {
          if (result.isConfirmed) {
            const res = result.value.data ? result.value.data.data : false;
            const error = result.value.data.error
                ? result.value.data.error
                : "Failed";

            if (res) {
              this.successmsg('Removed Parameter', 'Parameter is successfully removed')
              setTimeout(() => {
                this.getParameterStore();
              }, 2000);
            } else {
              this.warningmsg("Fail!", error);
            }
          }
        });
      },

    },
    middleware: "authentication",
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                          <div class="col-sm-12 col-md-3">
                            <a href="javascript:void(0);" class="btn btn-success waves-effect waves-light"
                               @click="addNewParameter">
                              <i class="mdi mdi-plus me-2"></i>Add New Parameter
                            </a>
                          </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-3">
                                <div class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Show&nbsp;
                                        <b-form-select
                                                v-model="perPage"
                                                size="sm"
                                                :options="pageOptions"
                                        ></b-form-select
                                        >&nbsp;entries
                                    </label>
                                </div>
                            </div>

                            <!-- Search -->
                            <div class="col-sm-12 col-md-9">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input
                                                v-model="filter"
                                                type="search"
                                                placeholder="Search..."
                                                class="form-control form-control-sm ms-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0">
                            <b-table
                                    :busy="isBusy"
                                    :items="tableData"
                                    :fields="fields"
                                    responsive="sm"
                                    :per-page="perPage"
                                    :current-page="currentPage"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    :filter="filter"
                                    :filter-included-fields="filterOn"
                                    show-empty
                                    empty-text="No Data Found"
                                    @filtered="onFiltered"
                            >

                                <template v-slot:cell(action)="data">
                                    <ul class="list-inline mb-0">
                                        <li class="list-inline-item">
                                            <a
                                                    href="javascript:void(0);"
                                                    class="px-2 text-primary"
                                                    title="Edit Parameter Store"
                                                    @click="callmodaleditParameterStore(data.item)"
                                            >
                                                <i class="uil uil-pen font-size-18"></i>
                                            </a>
                                        </li>
                                        <li class="list-inline-item">
                                          <a href="#" class="text-danger" @click="removeParameterValue(data.item.Name)" title="Remove Parameter Store Value">
                                            <i class="uil uil-trash-alt font-size-18"></i>
                                          </a>
                                        </li>
                                    </ul>
                                </template>

                                <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                    </div>
                                </template>

                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination
                                                v-model="currentPage"
                                                :total-rows="totalRows"
                                                :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

      <ModalAddParameterStoreData
          @onRefresh="getParameterStore"
      ></ModalAddParameterStoreData>

    </Layout>
</template>
